import axios from 'axios'
const { VUE_APP_PRINTIT_URL, VUE_APP_TEST_ERROR } = process.env
const getAtolCertificate = async (payload) => {
  const result = { error: false }
  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_PRINTIT_URL}/printit/api/atol`

    const res = await axios
      .post(url, payload, { responseType: 'blob' })

    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  getAtolCertificate
}
